import dayjs from 'dayjs';
import { Chip, Divider, LinearProgress, Skeleton } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import { KeyboardEvent, MouseEvent, SyntheticEvent, useEffect, useState } from 'react';

import { ClientCalendar } from '../Calendar';
import { Documents } from '../Documents/Documents';
import SocialEngagementTab from '../SocialEngagementTab/SocialEngagementTab';
import ClientSelectedHeader from './ClientSelectedHeader';
import AtheleteDetails from './AtheleteDetails';
import BusinessDetails from './BusinessDetails';
import style from './ClientSelected.module.css';
import TalentDetails from './TalentDetails';

import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import ActivityTab from 'components/shared/CustomDashboard/ActivityTab/ActivityTab';
import ContactTab from 'components/shared/CustomDashboard/ContactsTab/ContactTab';
import KeyDealsTab from 'components/shared/CustomDashboard/KeyDealsTab/KeyDealsTab';
import ActivityColumn from 'components/shared/CustomDashboard/Overview/Activity/ActivityColumn';
import DashboardDealCard from 'components/shared/CustomDashboard/Overview/DashboardDealCard';
import KeyDeals from 'components/shared/CustomDashboard/Overview/KeyDeals';
import OverviewTab from 'components/shared/CustomDashboard/Overview/OverviewTab';
import SocialEngagement from 'components/shared/CustomDashboard/Overview/SocialEngagement';
import TaskColumn from 'components/shared/CustomDashboard/Overview/Tasks/TaskColumn';
import TaskTab from 'components/shared/CustomDashboard/TaskTab/TaskTab';
import CustomDrawer from 'components/shared/CustomDrawer/CustomDrawer';
import CustomHomepage from 'components/shared/CustomHomePage/CustomHomepage';
import CustomModal from 'components/shared/CustomModal/CustomModal';

import { LightTooltip } from 'components/shared/CustomTooltip/CustomTooltip';

import ClientDrawer from 'pages/Dashboard/Client/ClientForm/FormDrawer/ClientDrawer';
import LinkingForm from 'pages/Dashboard/Client/ClientForm/Forms/LinkingForm';

import { ClientService } from 'service/client.service';
import { DashboardService } from 'service/dashboard.service';
import { HuddleClientService } from 'service/huddle-client.service';

import zeplinColor from 'theme/Color';

import { ReactComponent as DeleteRedIcon } from 'assets/delete-red.svg';

import { ClientType } from 'utilities/constants';

type SportsProps = {
  link: '';
  title: '';
  source: '';
};

const ClientSelected = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const client = location.state?.client;
  const captive8IdStored = sessionStorage.getItem('captive8Id');
  const captive8UrlStored = sessionStorage.getItem('captive8Url');
  const currentTab = sessionStorage.getItem('currentTab') || '0';

  const [value, setValue] = useState(0);
  const [alert, setAlert] = useState('');
  const [drawerState, setDrawerState] = useState(false);
  const splitPath = location.pathname?.split('/');
  const clientId = splitPath[3];

  const onClose = (open: boolean) => (event: KeyboardEvent | MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as KeyboardEvent).key === 'Tab' || (event as KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setDrawerState(open);
  };
  const onOpen = () => {
    setDrawerState(true);
  };

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentTab', newValue.toString());
    sessionStorage.removeItem('dealSelectedFromOverview');
    setValue(newValue);
  };

  const handleClose = () => {
    setAlert('');
  };

  const [data, setData] = useState<any>();
  const [details, setDetails] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [captive8loading, setCaptive8Loading] = useState(false);
  const [creatorInfo, setCreatorInfo] = useState<any>(null);
  const [editModal, setEditModal] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchor);
  const menuId = 'simple-popover';
  const [sportsData, setSportsData] = useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);

  const getDetails = async (id: string) => {
    setLoading(true);
    try {
      if (id) {
        const res = await HuddleClientService.getClientHuddleDetails(id);
        getCreatorInfo(res?.captiv8Id || res?.captive8CreatorId);

        setDetails({ accountName: res?.name, accountType: res?.recordType, ...res });
      }
    } catch (err: any) {
      setAlert(err?.message as string);
    } finally {
      setLoading(false);
    }
  };

  const getDeal = async (id: string) => {
    try {
      const res = await HuddleClientService.getHuddleClientDeal(id);

      setData(res);
    } catch (err: any) {
      setAlert(err?.message as string);
    }
  };

  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();

      setSportsData(res?.latestNews);
    } catch (err: any) {
      setAlert(`sports api : ${err?.message as string}`);
    }
  };

  const getCreatorInfo = async (id: string) => {
    try {
      if (id) {
        setCaptive8Loading(true);
        const res = await ClientService.getCreatorInfo(id);
        setCreatorInfo(res);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setCaptive8Loading(false);
    }
  };

  useEffect(() => {
    getDeal(clientId || '');
    getSportNews();
    getDetails(clientId || '');

    setValue(+currentTab || 0);
  }, [currentTab, clientId]);

  const DashboardTabs = [
    {
      label: 'Overview',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <OverviewTab
            channelID={client?.slackChannelId}
            setActiveTab={setValue}
            Column1={ActivityColumn}
            Column2={TaskColumn}
            Column3={SocialEngagement}
            creatorInfo={creatorInfo}
            AlternatColumn3={SocialEngagement}
            Column4={KeyDeals}
            setValue={setValue}
            captive8Url={client?.captive8Url}
            captive8Loading={captive8loading}
          />
        </Box>
      ),
    },
    {
      label: 'Activity',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ActivityTab />
        </Box>
      ),
    },
    {
      label: 'Task',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <TaskTab />
        </Box>
      ),
    },
    {
      label: 'Deals',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <KeyDealsTab getDeal={() => getDeal(clientId || '')} />
        </Box>
      ),
    },
    {
      label: 'Social Engagement',
      id: 5,
      isHidden: value !== 4,
      Component: (
        <Box>
          <SocialEngagementTab
            key={details?.captive8CreatorId || details?.captive8Id || captive8IdStored}
            captive8Id={details?.captiv8Id || captive8IdStored}
            captive8Url={details?.captive8Url || captive8UrlStored}
            getDetails={() => {
              getDetails(clientId || '');
            }}
          />
        </Box>
      ),
    },
    {
      label: 'Contacts',
      id: 6,
      isHidden: value !== 5,
      Component: (
        <Box>
          <ContactTab />
        </Box>
      ),
    },
    {
      label: 'Documents',
      id: 7,
      isHidden: value !== 6,
      Component: (
        <Box sx={{ height: '100%' }}>
          <Documents />
        </Box>
      ),
    },
    {
      label: 'Calendar',
      id: 8,
      isHidden: value !== 7,
      Component: (
        <Box sx={{ height: '100%' }}>
          <ClientCalendar />
        </Box>
      ),
    },
  ];

  const handleDeleteClick = (event: MouseEvent<HTMLDivElement>) => {
    setOpenModal((prev) => !prev);
  };

  const handleEditModal = (event: MouseEvent<HTMLDivElement>) => {
    setEditModal(true);
  };

  const editForm = (
    <ClientDrawer
      drawerState={editModal}
      typeSelected={details?.accountType?.split('_').join(' ')}
      data={details}
      setDrawerState={setEditModal}
      getAllClient={() => getDetails(clientId || '')}
    />
  );
  const handleDeleteConfirm = async (id: string) => {
    try {
      await HuddleClientService.deleteHuddleClient(id);
      navigate('/clients');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomHomepage
        CTA={
          value === 0 ? (
            <Box
              sx={{
                display: 'inline-flex',
                gap: '12px',
              }}
            >
              <LightTooltip
                title={
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    Manage Integrations
                  </Typography>
                }
                placement='bottom-end'
                style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
              >
                <Box
                  onClick={() => {
                    setLinkModal(true);
                  }}
                >
                  <CustomCard
                    styles={{
                      width: '100%',
                      borderRadius: { xs: '10px', xl: '14px' },
                      padding: '15px 12px',
                      backgroundColor: zeplinColor.Neutral1,
                      ':hover': {
                        backgroundColor: zeplinColor.Neutral4,
                      },
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      height: { xs: 30, xl: 48 },
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flex: 1,
                      gap: '8px',
                      textWrap: 'nowrap',
                    }}
                    aria-label='button'
                  >
                    <img
                      src='/assets/manage-icon.svg'
                      width={20}
                      height={20}
                      alt='manage-settings'
                    />
                    <Typography variant='responsiveButtonSmall' color={zeplinColor.BasicBlack}>
                      Manage Integrations
                    </Typography>
                  </CustomCard>
                </Box>
              </LightTooltip>
              <CustomButton
                style={{
                  width: '100%',
                  color: zeplinColor.Error,
                  borderColor: zeplinColor.Error,
                  backgroundColor: zeplinColor.Neutral1,
                  borderRadius: { xs: '10px', xl: '14px' },
                  ':hover': {
                    borderCollapse: zeplinColor.ErrorHover,
                    bgcolor: zeplinColor.BlockBG,
                  },
                }}
                variant={'outlined'}
                text={'Delete Client'}
                buttonVariant='responsiveButtonMedium'
                iconPosition='start'
                icon={<DeleteRedIcon />}
                onClick={handleDeleteClick}
                disabled={false}
              />
            </Box>
          ) : (
            <></>
          )
        }
        sportsData={sportsData}
        customHeader={
          <ClientSelectedHeader
            details={details}
            captive8loading={captive8loading}
            menuAnchor={menuAnchor}
            menuOpen={menuOpen}
            setMenuAnchor={setMenuAnchor}
            setEditModal={setEditModal}
            handleDeleteClick={handleDeleteClick}
          />
        }
        DashboardTabs={DashboardTabs}
        handleChange={handleChange}
        value={value}
        alert={alert}
        handleClose={handleClose}
        Children={
          editModal ? (
            editForm
          ) : (
            <CustomDrawer state={drawerState} onClose={onClose(false)}>
              <Box sx={{ width: { xs: '427px', xl: '527px' }, position: 'relative' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: { xs: '30px 20px 20px 20px', xl: '40px 24px 24px 24px' },
                  }}
                >
                  <Typography variant='responsiveHeading2'>Profile Details</Typography>
                  <img
                    src={'/assets/close-icon.svg'}
                    className={style['icon']}
                    alt='close'
                    style={{ cursor: 'pointer' }}
                    onClick={onClose(false)}
                  />
                </Box>
                <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '18px', xl: '24px' },
                  }}
                >
                  {' '}
                  <Box
                    sx={{
                      display: 'flex',
                      gap: { xs: '10px', xl: '16px' },
                      padding: { xs: '20px 20px 0px 20px', xl: '24px 24px 0px 24px' },
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: '55px', xl: '60px' },
                        height: { xs: '55px', xl: '60px' },
                        borderRadius: '14px',
                        backgroundColor: client?.avatar ? zeplinColor.Neutral1 : zeplinColor.Brand1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {captive8loading ? (
                        <Skeleton variant='rounded' width={60} height={60} />
                      ) : client?.avatar ? (
                        <img
                          className={style['profile-section-avatar']}
                          src={client?.avatar}
                          alt='logo'
                          loading='lazy'
                          style={{ objectFit: 'fill', borderRadius: '14px' }}
                        />
                      ) : (
                        <Typography
                          variant='responsiveDisplay4'
                          sx={{ color: zeplinColor.Neutral1 }}
                        >
                          {details?.accountName
                            ?.split(' ')
                            .map((val: any, index: number) =>
                              index === 0 || index === details?.accountName?.split(' ').length - 1
                                ? val[0]
                                : '',
                            )}
                        </Typography>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        flex: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          flex: 1,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: '8px' }}>
                            <LightTooltip
                              title={
                                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                                  {details?.accountName}
                                </Typography>
                              }
                              placement='bottom-start'
                              style={{
                                backgroundColor: zeplinColor.BasicBlack,
                                borderRadius: '8px',
                              }}
                            >
                              <Typography
                                variant='responsiveDisplay5'
                                color={zeplinColor.BasicBlack}
                                style={{
                                  textDecoration: 'none',
                                  display: 'inline-block',
                                  maxWidth: '220px',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                  verticalAlign: 'middle',
                                }}
                              >
                                {details?.accountName}
                              </Typography>
                            </LightTooltip>
                            {details?.league ? (
                              <Chip
                                label={
                                  <Typography
                                    variant='responsiveLabel1'
                                    color={zeplinColor.Neutral1}
                                    sx={{
                                      textAlign: 'center',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {details?.league ?? 'NA'}
                                  </Typography>
                                }
                                sx={{
                                  backgroundColor: zeplinColor.BasicBlack,
                                  padding: '5px 12px 5px 12px',
                                  borderRadius: '50px',
                                  height: '24px',
                                }}
                              />
                            ) : (
                              ''
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: { xs: '10px', xl: '16px' },
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={'/assets/edit.svg'}
                          className={style['icon']}
                          alt='edit'
                          style={{ cursor: 'pointer' }}
                          onClick={handleEditModal}
                        />
                        <img
                          src={'/assets/delete-red.png'}
                          className={style['icon']}
                          alt='close'
                          style={{ cursor: 'pointer' }}
                          onClick={handleDeleteClick}
                        />
                      </Box>
                    </Box>
                  </Box>
                  {details?.accountType?.split('_').join(' ') === ClientType?.Talent && (
                    <TalentDetails loading={loading} details={details} />
                  )}
                  {details?.accountType?.split('_').join(' ') === ClientType?.Athlete && (
                    <AtheleteDetails loading={loading} details={details} />
                  )}
                  {details?.accountType?.split('_').join(' ') === ClientType?.Business && (
                    <BusinessDetails loading={loading} details={details} />
                  )}
                </Box>
              </Box>
            </CustomDrawer>
          )
        }
      />
      <CustomModal handleClose={() => setOpenModal(false)} open={openModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: { xs: '20px', xl: '24px' },
              backgroundColor: zeplinColor.Neutral1,
              boxShadow: 'rgba(0, 0, 0, 0.15)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '22px', xl: '32px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Client?
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  You’re about to permanently delete{' '}
                  <Typography variant='responsiveHeading4'>{details?.accountName}</Typography>
                  <br /> and all related data. This action can’t be
                  <br /> undone. Are you sure you want to proceed?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Box
                  onClick={() => {
                    setOpenModal(false);
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                    aria-disabled={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    handleDeleteConfirm(details?.accountId);
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                    aria-disabled={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      {loading ? 'Deleting...' : 'Delete'}
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Box>
      </CustomModal>
      <LinkingForm
        modalOpen={linkModal}
        key={linkModal?.toString()}
        setLinkModal={setLinkModal}
        clientId={client?.AccountId}
        client={details || client}
        getAllClient={() => {
          getDetails(clientId || '');
        }}
      />
    </>
  );
};

export default ClientSelected;
